module.exports = __webpack_public_path__ + "media/future-ping.39adafcc.wav";